module.exports = __webpack_public_path__ + "settings.png?1c61a93a053139d79b848ea07eb86445";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/settings.png
// module id = 1012
// module chunks = 2